/** Enum of url links for landing page of subscriptions */
export enum SubscriptionPricingLink {
  EN = 'https://bkbn.com/en/pricing',
  DE = 'https://bkbn.com/de/pricing',
  FR = 'https://bkbn.com/fr/pricing',
  ES = 'https://bkbn.com/es/pricing',
  NL = 'https://bkbn.com/nl/pricing',
}
